export default () => (
  <svg
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M11.2314 3C15.7776 3 19.4636 6.6853 19.4639 11.2314C19.4639 13.1336 18.8159 14.8834 17.7324 16.2773L20.6982 19.2432C21.1 19.6449 21.0999 20.2964 20.6982 20.6982C20.2964 21.1001 19.645 21.1001 19.2432 20.6982L16.2773 17.7324C14.8834 18.8159 13.1336 19.4639 11.2314 19.4639C6.6853 19.4636 3 15.7776 3 11.2314C3.00025 6.68546 6.68546 3.00025 11.2314 3ZM11.2324 5.05762C7.82265 5.05762 5.05762 7.82265 5.05762 11.2324C5.05786 14.642 7.8228 17.4062 11.2324 17.4062C14.6418 17.406 17.406 14.6418 17.4062 11.2324C17.4062 7.8228 14.642 5.05786 11.2324 5.05762Z"
      fill="currentColor"
    />
  </svg>
);
